<ng-container
  *ngIf="facade.secondaryNavigationLinksDetails$ | ngrxPush as content"
>
  <idp-app-sec-links-seo
    [content]="content"
    [isMobile]="isMobile"
    [navigationId]="navigationId"
    (analyticsEvent)="emitAdobeAnalytics($event)"
  ></idp-app-sec-links-seo>
</ng-container>
